<template>
  <div class="info-row">
    <div class="label" :style="{textAlign: labelAlign,color:labelColor}"> {{ label }}</div>
    <div class="value"> {{ value }}</div>
  </div>
</template>

<script>
export default {
  name: "InfoRow",
  props: {
    label: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: ""
    },
    labelAlign: {
      type: String,
      default: "left"
    },
    labelColor: {
      type: String,
      default: "#333333"
    }
  }
};
</script>

<style scoped lang="less">
.info-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #939598;
  font-size: 14px;

  .label {
    flex: 1;
  }

  .value {
    flex: 1;
    text-align: right;
    color: #333333;
  }
}
</style>